// extracted by mini-css-extract-plugin
module.exports = {"tab":"styles_tab__YnS14","selected":"styles_selected__3dNnI","iconContainer":"styles_iconContainer__2-XAd"};